import { render, staticRenderFns } from "./modal_create.vue?vue&type=template&id=0f89d67e&scoped=true&"
import script from "./modal_create.vue?vue&type=script&lang=js&"
export * from "./modal_create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f89d67e",
  null
  
)

export default component.exports